module.exports = __webpack_public_path__ + "media/images/partner/pic_4-8912f9d0d7d2a66cdd23baecd810056d.png";